import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as codeActions from "../../../actions/codeActions";

const PtoRequestPeriodSelect = ({
  value: initialValue,
  onChange,
  codes = [],
  actions,
  disabled,
  auth
}) => {
  if (!codes.length) {
    actions.loadCodes();
  }
  if (!codes.length) {
    return null;
  }

  const options = codes
    .filter((code) => code.entity === "PTO Request" && code.field === "period")
    .map((d) => ({
      label: d.label,
      value: d._id,
      order: d.order
    }));

  const defaultOption = options.find((code) => code.order === 1);

  // default to full day
  const value = initialValue
    ? options.find((code) => code.value === initialValue)
    : defaultOption;

  const handleChange = (e) => {
    const val = options.find((code) => code.value === e.target.value);
    onChange(val.value, val.order);
  };
  const { isNightMode } = auth;
  return (
    <select
      value={value.value}
      order={value.order}
      onChange={handleChange}
      style={{
        border: "none",
        color: !isNightMode ? "rgb(92 77 77)" : "#fff",
        background: !isNightMode ? "#fff" : "rgb(92 77 77)"
      }}
      disabled={disabled}
    >
      {options.map((item, i) => (
        <option value={item.value} order={item.order} key={i}>
          {item.label}
        </option>
      ))}
    </select>
  );
};

PtoRequestPeriodSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  codes: PropTypes.array,
  actions: PropTypes.object,
  auth: PropTypes.object,
  disabled: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes,
    auth: state.reducers.auth
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(PtoRequestPeriodSelect);
